module.exports = __webpack_public_path__ + "img/46.3bc68272.jpg";